// Configuração da API
export const API_CONFIG = {
  BASE_URL: "https://turminha-educa-api-366a3598241b.herokuapp.com",
  // BASE_URL: 'http://localhost:3001',
  TIMEOUT: 10000, // 10 segundos
  RETRY_ATTEMPTS: 3,
};

// Headers padrão
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

// Configurações de autenticação
export const AUTH_CONFIG = {
  TOKEN_KEY: 'accessToken',
  REFRESH_TOKEN_KEY: 'refreshToken',
  LEGACY_TOKEN_KEY: 'token', // Para compatibilidade
};
